
import {defineComponent, PropType} from "vue";
import {Helper} from "@/utils/helper";
import {Image} from "@/models/image";
import {Campaign} from "@/models/campaign";

export default defineComponent({
    props: {
        campaign: { type: Object as PropType<Campaign>, required: true },
    },
    computed: {
        backgroundImageURL(): string | undefined {
            if (this.backgroundImage) {
                return Helper.getImageUrl(this.backgroundImage, 900, 1600);
            }

            return undefined;
        },
        backgroundImage(): Image | undefined {
            if (this.campaign.backgroundImage) {
                return this.campaign.backgroundImage;
            }

            return undefined;
        },
        showBackgroundImage(): boolean {
            return this.backgroundImage !== undefined;
        },
    },
});
